var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 7.36694H11.5V4.24194C11.5 3.24738 11.1049 2.29355 10.4017 1.59029C9.69839 0.887031 8.74456 0.491943 7.75 0.491943C6.75544 0.491943 5.80161 0.887031 5.09835 1.59029C4.39509 2.29355 4 3.24738 4 4.24194V7.36694H1.34375C1.21943 7.36694 1.1002 7.41633 1.01229 7.50424C0.924386 7.59214 0.875 7.71137 0.875 7.83569V18.7732C0.875 18.8975 0.924386 19.0167 1.01229 19.1047C1.1002 19.1926 1.21943 19.2419 1.34375 19.2419H14.1562C14.2806 19.2419 14.3998 19.1926 14.4877 19.1047C14.5756 19.0167 14.625 18.8975 14.625 18.7732V7.83569C14.625 7.71137 14.5756 7.59214 14.4877 7.50424C14.3998 7.41633 14.2806 7.36694 14.1562 7.36694ZM10.0156 7.36694H5.48438V4.21265C5.48438 3.61177 5.72307 3.03549 6.14796 2.61061C6.57285 2.18572 7.14912 1.94702 7.75 1.94702C8.35088 1.94702 8.92715 2.18572 9.35204 2.61061C9.77693 3.03549 10.0156 3.61177 10.0156 4.21265V7.36694Z",
    fill: "#01295F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdIcon);
export default __webpack_public_path__ + "static/media/PwdIcon.071eee5e47eefd69a7c91d2a62e8e9a3.svg";
export { ForwardRef as ReactComponent };